import React from 'react';
import {FileOutlined, FolderFilled, ProfileTwoTone} from '@ant-design/icons';
import {getExtFromName, getPreviewType} from '../../utils/filePreview';
import {fileIconMap} from '../../constants/fileIconMap';
import './index.scss';

export function FileThumbnail({file}: { file: any }) {
  const thumbnail = file?.thumbnail || file?.thumbnail_url;

  if (thumbnail?.trim()) {
    return (
      <img
        src={thumbnail}
        alt=""
        className="drive-file-thumbnail"
      />
    );
  }

  if (file.type === 'directory') {
    const Icon = file.is_group ? ProfileTwoTone : FolderFilled;
    const className = file.is_group
      ? 'drive-file-thumbnail drive-file-thumbnail--directory'
      : 'drive-file-thumbnail drive-file-thumbnail--folder';
    return <Icon className={className}/>;
  }

  const ext = file.extension || getExtFromName(file.file_name || file.name);

  const previewType = getPreviewType(ext);

  if (previewType === 'default') {
    return <FileOutlined className="drive-file-thumbnail drive-file-thumbnail--file"/>;
  }

  return (
    <img
      src={fileIconMap[previewType] || fileIconMap['default']}
      alt=""
      className="drive-file-thumbnail"
    />
  );
}